<template>
  <div class="md:mx-auto md:max-w-[1280px] w-full justify-center px-3 md:px-0">
    <slot />
  </div>
</template>

<script setup></script>
